<div class="equipment-container">
  <div class="row-block">
    <ng-container *ngIf="equipmentArray.length > 0; else showMessageTemplate">
      <div class="content-wrapper">
        <ng-container *ngIf="!showMessage; else showMessageTemplate">
          <app-equipment-details *ngIf="selectedItem" [selectedItem]="selectedItem" [userData]="userData" [mobile]="mobile"></app-equipment-details>
        </ng-container>
      </div>
    </ng-container>
  </div>
  <ng-template #showMessageTemplate>
    <app-equipment-empty *ngIf="!isLoading"></app-equipment-empty>
  </ng-template>
</div>
<app-loader *ngIf="isLoading"></app-loader>
